import type { Provider } from "@angular/core";

import type { ApiConfigurationParams } from "./packbo/api-configuration";
import { ApiConfiguration } from "./packbo/api-configuration";

export function provideApi(params: ApiConfigurationParams): Provider[] {
    return [
        {
            provide: ApiConfiguration,
            useValue: params
        }
    ];
}
